import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<CreateDynamicLinkResponse, CreateDynamicLinkRequest>({
    query: (body) => ({
      url: 'v5/link/generate',
      method: 'POST',
      body,
    }),
  });

export interface CreateDynamicLinkRequest {
  target_type: string;
  target_id?: string;
  expiry_date?: string | null;
  title: string;
  source?: string;
}

export interface CreateDynamicLinkResponse {
  data: {
    url: string;
  };
  code: number;
}
